package com.example.mystybag.login.views.components

import androidx.compose.foundation.background
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import com.example.mystybag.core.ui.theme.LocalTheme.p4
import com.example.mystybag.core.views.AppTheme

/**
 * Progress fill fractions for the merchant registration flow (unchanged from per-screen Figma values).
 */
object MerchantRegistrationProgressFractions {
    /** Step 1 — company identifier (BULSTAT). */
    const val COMPANY_IDENTIFIER = 0.2f

    /** Step 2 — company details / contact. */
    const val COMPANY_DETAILS = 0.4f

    /** Step 3 — responsible persons (MOL). Same while adding/editing a single MOL. */
    const val RESPONSIBLE_PERSONS = 247f / 412f

    /** Step 4 — payment (IBAN). */
    const val PAYMENT_DATA = 330f / 412f

    /** Step 5 — login credentials (4.5 of 5 segments). */
    const val LOGIN_DETAILS = 4.5f / 5f
}

@Composable
fun MerchantRegistrationProgressBar(
    progressFraction: Float,
    modifier: Modifier = Modifier
) {
    val colors = AppTheme.current.colors
    val fill = progressFraction.coerceIn(0f, 1f)
    Box(
        modifier = modifier
            .fillMaxWidth()
            .height(p4)
    ) {
        Box(
            modifier = Modifier
                .fillMaxSize()
                .background(colors.primaryContainer)
        )
        Box(
            modifier = Modifier
                .fillMaxWidth(fill)
                .height(p4)
                .background(colors.primary)
        )
    }
}
